import React from 'react';
import { CmonJobInstanceCommand } from '../../services/cmon/models/CmonJobInstance';
import ActionButton from '@severalnines/bar-frontend-components/build/lib/General/ActionButton';
import JobButtonBarrier from '../../common/Barrier/JobButtonBarrier';
import { CcClusterType } from '../../services/models/CcCluster';
import JobWatcherButton from './JobWatcherButton';
import ButtonWithSwitch from '../../common/General/ButtonWithSwitch';

export default JobActionButton;

export type JobActionButtonProps = {
    clusterId?: number;
    clusterType?: CcClusterType;
    command: CmonJobInstanceCommand;
    children?: React.ReactNode;
    critical?: boolean;
    extraKey?: (string | number | undefined)[];
    disabled?: boolean;
    switchValue?: boolean;
    tooltip?: React.ReactNode;
};

function JobActionButton({
    clusterId,
    clusterType,
    command,
    critical,
    children,
    extraKey,
    switchValue,
    tooltip,
    ...rest
}: JobActionButtonProps) {
    return (
        <JobButtonBarrier command={command} clusterType={clusterType}>
            <JobWatcherButton
                command={command}
                clusterId={clusterId}
                extraKey={extraKey}
                button={
                    <ButtonWithSwitch
                        switchValue={switchValue}
                        tooltip={tooltip}
                        button={
                            <ActionButton
                                critical={critical}
                                className="JobActionButton"
                            >
                                {children}
                            </ActionButton>
                        }
                        {...rest}
                    />
                }
            />
        </JobButtonBarrier>
    );
}
